// src/modules/Audit/StoreAudits.js

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BackButton from '../../components/BackButton'; // Adjust the import path as necessary - problem i faced earlier with this
import { FiFilter, FiChevronUp, FiChevronDown } from 'react-icons/fi';

const StoreAudits = () => {
  const navigate = useNavigate();
  const [audits, setAudits] = useState([]);
  const [filteredAudits, setFilteredAudits] = useState([]);
  const [filter, setFilter] = useState('');
  const [sortField, setSortField] = useState('date');
  const [sortDirection, setSortDirection] = useState('desc');

  useEffect(() => {
    // Fetch audits data here
    // using mock data
    const mockAudits = [
      { id: 1, date: '2023-06-01', branch: 'Store A', score: 85 },
      { id: 2, date: '2023-06-02', branch: 'Store B', score: 92 },
      { id: 3, date: '2023-06-03', branch: 'Store C', score: 78 },
      { id: 4, date: '2023-06-04', branch: 'Store D', score: 88 },
      { id: 5, date: '2023-06-05', branch: 'Store E', score: 95 },
    ];
    setAudits(mockAudits);
    setFilteredAudits(mockAudits);
  }, []);

  useEffect(() => {
    const filtered = audits.filter(audit => 
      audit.branch.toLowerCase().includes(filter.toLowerCase()) ||
      audit.date.includes(filter)
    );
    setFilteredAudits(filtered);
  }, [filter, audits]);

  const handleSort = (field) => {
    if (field === sortField) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }

    const sorted = [...filteredAudits].sort((a, b) => {
      if (a[field] < b[field]) return sortDirection === 'asc' ? -1 : 1;
      if (a[field] > b[field]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
    setFilteredAudits(sorted);
  };

  const SortIcon = ({ field }) => {
    if (sortField !== field) return null;
    return sortDirection === 'asc' ? <FiChevronUp /> : <FiChevronDown />;
  };

  return (
    <div className="bg-gray-100 min-h-screen p-8">
      <BackButton />
      <h1 className="text-3xl font-bold mb-6">Store Audits</h1>
      <div className="bg-white rounded-lg shadow-lg p-6">
        <div className="mb-4 flex items-center">
          <FiFilter className="mr-2" />
          <input
            type="text"
            placeholder="Filter by branch or date"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="p-2 border rounded w-full"
          />
        </div>
        <table className="w-full">
          <thead>
            <tr className="bg-gray-200">
              <th className="p-2 text-left cursor-pointer" onClick={() => handleSort('date')}>
                Date <SortIcon field="date" />
              </th>
              <th className="p-2 text-left cursor-pointer" onClick={() => handleSort('branch')}>
                Branch <SortIcon field="branch" />
              </th>
              <th className="p-2 text-left cursor-pointer" onClick={() => handleSort('score')}>
                Score <SortIcon field="score" />
              </th>
              <th className="p-2 text-left">Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredAudits.map((audit) => (
              <tr key={audit.id} className="border-b">
                <td className="p-2">{audit.date}</td>
                <td className="p-2">{audit.branch}</td>
                <td className="p-2">{audit.score}%</td>
                <td className="p-2">
                  <button
                    onClick={() => navigate(`/audit/${audit.id}`)}
                    className="text-blue-500 hover:underline"
                  >
                    View Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StoreAudits;